/** Casing value: uppercase (Groß). */
export const CASING_GROSS = 'Groß (AA)';

/** Casing value: mixed case (Gemischt). */
export const CASING_GEMISCHT = 'Gemischt (Aa)';
